<template>
    <div class="animated fadeIn">
        <form @submit.prevent="validate" class="needs-validation" novalidate>
            <b-card header-tag="header">
                <div slot="header">
                    <i class="icon-people"></i> Representantes
                    <b-link :to="`/partners/salespeople`" class="btn mr-2 btn-sm btn-primary float-right">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                    </b-link>
                </div>
                <b-tabs pills card justified>
                    <b-tab title="1. Representante" active>
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Dados do Representante</h4>
                        <hr class="mb-3"/>
                        <div class="form-row justify-content-start">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label for="name">Cpf</label>
                                    <the-mask type="tel" placeholder="Digite o cpf" v-model="salesPerson.documentNumber" v-validate="modelValidations.documentNumber" :class="{'form-control': true, 'is-invalid': errors.has('documentNumber')}" data-vv-name="documentNumber" data-vv-as="cpf / cnpj" :mask="['###.###.###-##']" :disabled="action == 'edit_salesperson'" />
                                    <div v-show="errors.has('documentNumber')" class="invalid-feedback">
                                        {{ errors.first('documentNumber') }}
                                    </div>                                
                                </div>
                            </div>
                        </div>
                        <div class="form-row justify-content-start">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="name">Nome</label>
                                    <input type="text" placeholder="Digite o nome" v-model="salesPerson.name" v-validate="modelValidations.name" :class="{'form-control': true, 'is-invalid': errors.has('name')}" data-vv-name="name" data-vv-as="nome" maxlength="150" />
                                    <div v-show="errors.has('name')" class="invalid-feedback">
                                        {{ errors.first('name') }}
                                    </div>
                                </div>
                            </div>                                 
                        </div>
                        <div class="form-row justify-content-start">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label for="name">RG</label>
                                    <the-mask type="tel" placeholder="Digite o RG" v-model="salesPerson.identityDocument" v-validate="modelValidations.identityDocument" :class="{'form-control': true, 'is-invalid': errors.has('identityDocument')}" data-vv-name="identityDocument" data-vv-as="RG" :mask="['##.###.###-#']" />
                                    <div v-show="errors.has('identityDocument')" class="invalid-feedback">
                                        {{ errors.first('identityDocument') }}
                                    </div>
                                </div>
                            </div>            
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="exampleFormControlSelect12">Gênero</label>
                                    <select :class="{'form-control': true, 'is-invalid': errors.has('gender')}" v-validate="modelValidations.gender" v-model="salesPerson.gender" data-vv-name="gender" data-vv-as="gênero">
                                        <option v-for="(gender, index) in genderList" :key="index" :value="gender.id">
                                            {{gender.name}}
                                        </option>
                                    </select>
                                    <div v-show="errors.has('gender')" class="invalid-feedback">
                                        {{ errors.first('gender') }}
                                    </div>
                                </div>
                            </div>                
                        </div>
                        <div class="form-row justify-content-start">
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="status">Status</label>
                                    <select :class="{'form-control': true, 'is-invalid': errors.has('status')}" v-validate="modelValidations.status" v-model="salesPerson.status" data-vv-name="status" data-vv-as="Status">
                                        <option v-for="(item, index) in statusList" :key="index" :value="item.status">
                                            {{item.name}}
                                        </option>
                                    </select>                                    
                                    <div v-show="errors.has('status')" class="invalid-feedback">
                                        {{ errors.first('status') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row justify-content-start">
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="status">Perfil</label>
                                    <select :disabled="action == 'edit_salesperson'" ref="level" :class="{'form-control': true, 'is-invalid': errors.has('level')}" v-validate="modelValidations.level" v-model="salesPerson.level" data-vv-name="level" data-vv-as="Perfil">
                                        <option v-for="(item, index) in roleList" :key="index" :value="item.role">
                                            {{item.name}}
                                        </option>
                                    </select>                                    
                                    <div v-show="errors.has('level')" class="invalid-feedback">
                                        {{ errors.first('level') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2" v-if="salesPerson.level != null && salesPerson.level != 'MANAGER'">
                                <div class="form-group">
                                    <label for="status">Líder</label>
                                    <select :class="{'form-control': true, 'is-invalid': errors.has('parentId')}" v-validate.immediate="'required_if:level,LEAD,EMPLOYEE'" v-validate="modelValidations.parentId" v-model="salesPerson.parentId" data-vv-name="parentId" data-vv-as="Líder">
                                        <option v-for="(item, index) in salesPersonList" :key="index" :value="item.id">
                                            {{item.name}}
                                        </option>
                                    </select>                                    
                                    <div v-show="errors.has('level')" class="invalid-feedback">
                                        {{ errors.first('level') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mt-3">Contato</h5>
                            <hr class="mb-3" />
                        <div class="form-row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="name">E-mail</label>
                                    <input type="email" placeholder="Digite seu e-mail" v-model="salesPerson.email" v-validate="modelValidations.email" :class="{'form-control': true, 'is-invalid': errors.has('email')}" data-vv-name="email" data-vv-as="e-mail" maxlength="255" />
                                    <div v-show="errors.has('email')" class="invalid-feedback">
                                        {{ errors.first('email') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row justify-content-start">
                            <div class="col-sm-1">
                                <div class="form-group">
                                    <label for="name">DDD</label>
                                    <the-mask type="tel" placeholder="DDD" v-model="salesPerson.phone.areaCode" v-validate="modelValidations.areaCode" :class="{'form-control': true, 'is-invalid': errors.has('areaCode')}" data-vv-name="areaCode" data-vv-as="DDD" :mask="['##']" />
                                    <div v-show="errors.has('areaCode')" class="invalid-feedback">
                                        {{ errors.first('areaCode') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="name">Telefone</label>                                    
                                    <the-mask type="tel" placeholder="Digite seu telefone" v-model="salesPerson.phone.number" v-validate="modelValidations.phoneNumber" :class="{'form-control': true, 'is-invalid': errors.has('phoneNumber')}" data-vv-name="phoneNumber" data-vv-as="telefone" :mask="['####-####', '#####-####']" />
                                    <div v-show="errors.has('phoneNumber')" class="invalid-feedback">
                                        {{ errors.first('phoneNumber') }}
                                    </div>
                                </div>
                            </div>
                        </div>        
                        <h4 class="mt-3">Endereço</h4>
                        <hr class="mb-3"/>
                        <div class="form-row">
                            <div class="col-sm-2 justify-content-start">
                                <div class="form-group">
                                    <label for="name">Cep</label>
                                    <the-mask type="tel" placeholder="Digite seu Cep" v-model="salesPerson.address.zipCode" v-validate="modelValidations.zipCode" :class="{'form-control': true, 'is-invalid': errors.has('zipCode')}" data-vv-name="zipCode" data-vv-as="cep" :mask="['#####-###']" />
                                    <div v-show="errors.has('zipCode')" class="invalid-feedback">
                                        {{ errors.first('zipCode') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <label for="name">Logradouro</label>
                                    <input type="text" placeholder="Digite o endereço" v-model="salesPerson.address.street" v-validate="modelValidations.street" :class="{'form-control': true, 'is-invalid': errors.has('street')}" data-vv-name="street" data-vv-as="endereço" maxlength="255" />
                                    <div v-show="errors.has('street')" class="invalid-feedback">
                                        {{ errors.first('street') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="name">Numero</label>
                                    <input type="text" placeholder="Digite o numero" v-model="salesPerson.address.number" v-validate="modelValidations.number" :class="{'form-control': true, 'is-invalid': errors.has('number')}" data-vv-name="number" data-vv-as="número" maxlength="20" />
                                    <div v-show="errors.has('number')" class="invalid-feedback">
                                        {{ errors.first('number') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="name">Complemento</label>
                                    <input type="text" placeholder="Digite o complemento" v-model="salesPerson.address.complement" :class="{'form-control': true}" maxlength="250" />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="name">Bairro</label>
                                    <input type="text" placeholder="Digite o bairro" v-model="salesPerson.address.district" v-validate="modelValidations.district" :class="{'form-control': true, 'is-invalid': errors.has('district')}" data-vv-name="district" data-vv-as="bairro" maxlength="250" />
                                    <div v-show="errors.has('district')" class="invalid-feedback">
                                        {{ errors.first('district') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="name">Cidade</label>
                                    <input type="text" placeholder="Digite a cidade" v-model="salesPerson.address.city" v-validate="modelValidations.city" :class="{'form-control': true, 'is-invalid': errors.has('city')}" data-vv-name="city" data-vv-as="cidade" maxlength="250" />
                                    <div v-show="errors.has('city')" class="invalid-feedback">
                                        {{ errors.first('city') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-2 justify-content-start">
                                <div class="form-group">
                                    <label for="stateSelect">Estado</label>
                                    <select :class="{'form-control': true, 'is-invalid': errors.has('state')}" v-validate="modelValidations.state" v-model="salesPerson.address.state" data-vv-name="state" data-vv-as="estado">
                                        <option value="">Selecione um estado:</option>
                                        <option v-for="(s, index) in stateList" :key="index" :value="s">
                                            {{s}}
                                        </option>
                                    </select>
                                    <div v-show="errors.has('state')" class="invalid-feedback">
                                        {{ errors.first('state') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="2. Dados Bancários">
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Dados Bancários</h4>
                        <hr class="mb-3"/>
                        <bank-account v-model="bankAccount" :action="action" />
                    </b-tab>
                    <b-tab title="3. Dados de Acesso">
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Dados de Acesso</h4>
                        <hr class="mb-3"/>
                        <user-input v-model="user" :action="action" />
                    </b-tab>
                </b-tabs>
                <div slot="footer">
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </div>            
            </b-card>
        </form>
    </div>
</template>
<script>
import helperService from '../../../services/Helper/helperService'
import salesPersonService from '../../../services/Customer/salesPersonService'
import editPage from '../../../mixins/editPage'
import BankAccount from '../../../components/customers/bankAccount.vue'
import UserInput from '../../../components/customers/userInput.vue'
export default {
    components: { BankAccount, UserInput },
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            salesPerson: {
                name: '',
                documentNumber: '',
                identityDocument: null,
                gender: null,
                birthDate: null,
                phone: {
                    areaCode: '',
                    number: ''
                },
                email: '',
                status: null,
                id: '',
                type: 'F',
                address: {
                    street: '',
                    number: '',
                    complement: '',
                    district: '',
                    state: '',
                    city: '',
                    zipCode: '',
                    type: ''
                },
                level: null,
                parentId: null,
            },  
            bankAccount: {
                owner: '',
                document: '',
                number: '',
                branchNumber: '',
                documentType: '',
                bankCode: null,
                type: null,
                pagBankEmail: '',
                customerId: '',
                status: 'ACTIVE'
            },
            user: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    areaCode: '',
                    number: ''
                },
                id: '',
                customerId: '',
                role: 'Salesperson',
                blocked: false
            },                    
            roleList:[
                { 
                    role: null,
                    name: 'Selecione:'
                },
                { 
                    role: 'MANAGER',
                    name: 'Nível 1'
                },
                { 
                    role: 'LEAD',
                    name: 'Nível 2'
                },
                { 
                    role: 'EMPLOYEE',
                    name: 'Nível 3'
                },
            ],
            genderList: [
                {
                    id: null,
                    name: 'Selecione'
                },
                {
                    id: 'MALE',
                    name: 'Masculino'
                },
                {
                    id: 'FEMALE',
                    name: 'Feminino'
                },
                {
                    id: 'OTHER',
                    name: 'Outro'
                }
            ],
            salesPersonList: [],
            stateList: [
                'AC',
                'AL',
                'AM',
                'AP',
                'BA',
                'CE',
                'DF',
                'ES',
                'GO',
                'MA',
                'MG',
                'MS',
                'MT',
                'PA',
                'PB',
                'PE',
                'PI',
                'PR',
                'RJ',
                'RN',
                'RO',
                'RR',
                'RS',
                'SC',
                'SE',
                'SP',
                'TO'
            ],
            statusList: [
                {
                    status: null,
                    name: 'Selecione'
                },
                {
                    status: 'ACTIVE',
                    name: 'Ativo'
                },
                {
                    status: 'INACTIVE',
                    name: 'Inativo'
                },
                {
                    status: 'BLOCKED',
                    name: 'Bloqueado'
                }
            ],
            modelValidations: {
                name: {
                    required: true,
                    max: 150
                },
                documentNumber: {
                    required: true,
                },
                identityDocument: {
                    required_if: 'sellerType,F'
                },                
                gender: {
                    required_if: 'sellerType,F'
                },
                email: {
                    required: true,
                    email: true
                },
                areaCode: {
                    required: true,
                },
                phoneNumber: {
                    required: true,
                },
                status: {
                    required: true,
                },
                level: {
                    required: true,
                },
                parentId: {
                    required_if: 'level,LEAD,EMPLOYEE'
                },
                street: {
                    required: true,
                },
                number: {
                    required: true,
                },
                district: {
                    required: true,
                },
                state: {
                    required: true,
                },
                city: {
                    required: true,
                },
                zipCode: {
                    required: true,
                }                
            }        
        }
    },
    computed: {
        action() {
            return this.$route.name
        }
    },
    watch: {
        'salesPerson.address.zipCode': function(value) {
        if (value && value.length == 8) {
            this.getAddressData(value)
            }
        },
        'salesPerson.level': function(value) {
            if(value == null || value == 'MANAGER') {
                this.salesPersonList = []
            }
            else {
                this.getSalesPersonData() 
            }
        },
        'salesPerson.documentNumber': function(value) {        
            this.bankAccount.document = value
        },       
        'salesPerson.name': function(value) {
            this.bankAccount.owner = this.salesPerson.name
        },
    },
    created(){
        this.fetchUserData()
    },
    methods: {
        fetchUserData() {
            const self = this            
            if(this.action == 'edit_salesperson') {
                self.showLoading()
                salesPersonService.findDetailed(self.id).then((response) => {
                    self.salesPerson = {
                        name: response.data.name,
                        documentNumber: response.data.documentNumber,
                        identityDocument: response.data.identityDocument ? response.data.identityDocument : null,
                        gender: response.data.gender ? response.data.gender : null,
                        birthDate: null,
                        phone: {
                            areaCode: response.data.phone.areaCode,
                            number: response.data.phone.number
                        },
                        email: response.data.email,
                        status: response.data.status,
                        id: response.data.id,
                        type: response.data.type,
                        address: {
                            street: '',
                            number: '',
                            complement: '',
                            district: '',
                            state: '',
                            city: '',
                            zipCode: '',
                            type: ''
                        },
                        level: response.data.level,
                        parentId: response.data.parentId
                    }

                    self.salesPerson.address = response.data.addresses != null && response.data.addresses.length > 0 ?
                        response.data.addresses[0] 
                        :
                        self.salesPerson.address 
                    self.user = response.data.users[0]
                    self.bankAccount = response.data.bankAccount
                }, () => {
                    self.hideLoading()
                })
            }
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    self.user.role = 'Salesperson'
                    let request = self.salesPerson
                    request.bankAccount = self.bankAccount
                    request.user = self.user
                    request.id = self.id
                    if(this.action == 'new_salesperson') {                        
                        salesPersonService.createSalesPerson(request).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:'/partners/salespeople'})
                        }, (error) => {
                            self.hasError = true
                            self.errorMessage = error.response.data.message
                            self.hideLoading()
                        })
                    }
                    else {                        
                        salesPersonService.updateSalesPerson(request).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:'/partners/salespeople'})
                        }, (error) => {
                            self.hasError = true
                            self.errorMessage = error.response.data.message
                            self.hideLoading()
                        })
                    }
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        },
        getSalesPersonData() {
            const self = this 
            self.showLoading()
            let level = this.salesPerson.level == 'LEAD' ? 'MANAGER' : 'LEAD'           
            salesPersonService.all('', level).then((response) =>{
                self.salesPersonList = response.status == 204 ? [] : response.data
                self.salesPersonList.unshift({ id: null, name: 'Selecione'})
                self.hideLoading()
            }, () =>{
                self.hideLoading()
            })
        },
        getAddressData(zipCode) {
            const self = this
            self.showLoading()
            helperService.getAddressFromZipCode(zipCode).then(
                response => {
                    if(response && response.erro) {
                        self.hideLoading()
                        return
                    }
                    self.salesPerson.address.street = response.logradouro
                    self.salesPerson.address.complement = response.complemento
                    self.salesPerson.address.district = response.bairro
                    self.salesPerson.address.city = response.localidade
                    self.salesPerson.address.state = response.uf
                    self.hideLoading()
                },
                () => {
                    self.hideLoading()
                }
            )
        },
        clearZipCodeValue() {
        this.$refs.zipcode.clearValue()
        }     
    }
}
</script>
